import Vue from 'vue'
import { defineNuxtPlugin } from '@nuxtjs/composition-api'
const ImageZoom = require('vue-image-zoomer').default

export default defineNuxtPlugin(() => {
  Vue.component('ImageZoom', ImageZoom)
})
